module.exports = __webpack_public_path__ + "img/en.b3274577.png";